const BASE_URL = process.env.VUE_APP_REPORT_BASE_URL || "https://inqbox.q19.kz";
export default BASE_URL;
